
import { RouteObject } from "react-router-dom";
import NotFound from "../../pages/NotFound";
import ServerError from "../../pages/ServerError";
import { authRoutes } from "../../features-v2/auth/routes";
import { guestPortalRoutes } from "../../features-v2/guest-portal/routes";
import GuestPortalLanding from "../../features-v2/guest-portal/components/Landing";
import { billingPaymentRoutes } from "@features/billingPayment";
import { usageconsumptioRoutes } from "@features/usage-consumptio";
import { requestTrackerRoutes } from "@features/requestTracker";
import { faqsRoutes } from "@features/faqs";
import { contactUsRoutes } from "@features/contactUs";
import { PreferencesRoutes } from "@features/Preferences";
import { notificationsRoutes } from "@features/notifications"; // Remove this if no longer needed, or keep for other routes
// old profile routes removed
import { serviceRequestRoutes } from "@features/serviceRequest";
import { requestsRoutes } from "../../features-v2/requests/routes";
import { dashboardRoutes } from "../../features-v2/dashboard/route";
import { billsRoutes } from "../../features-v2/bills/routes";
import { allAccountsRoutes } from "../../features-v2/all-accounts/routes";
import { consumptionRoutes } from "../../features-v2/consumption/routes";
import { supportCenterRoutes } from "../../features-v2/support-center/routes";
import { profileRoutes } from "../../features-v2/profile/routes";
import { notificationRoutes as v2NotificationRoutes } from "../../features-v2/notification/routes";

export interface AppRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: AppRoute[];
}

export const routes: AppRoute[] = [
  {
    path: "/",
    element: <GuestPortalLanding />,
  },
  ...guestPortalRoutes,
  ...authRoutes,
  ...billingPaymentRoutes,
  ...usageconsumptioRoutes,
  ...requestTrackerRoutes,
  ...faqsRoutes,
  ...contactUsRoutes,
  ...PreferencesRoutes,
  // ...notificationsRoutes, (v1 replaced by v2)
  ...v2NotificationRoutes,
  // ...ProfileRoutes removed
  ...serviceRequestRoutes,
  ...dashboardRoutes,
  ...requestsRoutes,
  ...billsRoutes,
  ...allAccountsRoutes,
  ...consumptionRoutes,
  ...supportCenterRoutes,
  ...profileRoutes,

  {
    path: "/500",
    element: <ServerError />,
  },
  {
    path: "*",
    element: <NotFound />,
  },  
];
